// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6097":"2c8b4531","6892":"a2a42570","7792":"04a322bc"}[chunkId] + ".chunk.css";
};